import { Grid } from "@mui/material";
import AdminSidebar from "./Sidebar";

export default function Team() {


    return (
        <>


            <Grid container height={'100vh'} className='admin-body' width={'100%'}>
                <AdminSidebar />

                <Grid height={'100vh'} size={{ lg: 10 }} px={3} pt={3}>

                </Grid>

            </Grid>

        </>
    )

}